const fonts = {
  header: 'Helvetica, sans-serif',
  body: 'Avenir, sans-serif',
};

export default fonts;
